// Campos de WhatsApp (shared/_phone_field): solo dígitos y máximo 10.
// Si pegan o autocompletan el número con lada ("+1 415 555 0100"), elige esa bandera y deja los 10 dígitos.
// Escucha en document para cubrir también los bloques de asistentes que se crean con JS.

const LOCAL_DIGITS = 10;

const detectDial = (digits, select) => {
  const dials = Array.from(select.options).map((option) => option.value).sort((a, b) => b.length - a.length);
  for (const dial of dials) {
    if (!digits.startsWith(dial)) continue;
    let local = digits.slice(dial.length);
    // "+52 1 222…": el 1 móvil viejo de México.
    if (dial === '52' && local.length === LOCAL_DIGITS + 1 && local.startsWith('1')) local = local.slice(1);
    if (local.length === LOCAL_DIGITS) return { dial, local };
  }
  return null;
};

document.addEventListener('input', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches('[data-phone-local]')) return;

  const raw = input.value;
  let digits = raw.replace(/\D/g, '');
  const select = input.closest('[data-phone-input]')?.querySelector('[data-phone-country]');

  if (select && (raw.trim().startsWith('+') || digits.length > LOCAL_DIGITS)) {
    const match = detectDial(digits, select);
    if (match) {
      select.value = match.dial;
      digits = match.local;
    }
  }

  digits = digits.slice(0, LOCAL_DIGITS);
  if (input.value === digits) return;

  input.value = digits;
  // Los formularios que validan en 'input' ya corrieron con el valor sin limpiar.
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
